import template from './addEmployeeModal.html';
import controller from './addEmployeeModal.controller';

let AddEmployeeModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'invoice-modal-popup hmodal-info animated zoomIn'
}

export default AddEmployeeModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/addEmployeeModal/addEmployeeModal.component.js